import { render } from "./block-types.vue?vue&type=template&id=951da652&ts=true"
import script from "./block-types.vue?vue&type=script&lang=ts"
export * from "./block-types.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__